<ng-container *ngIf="trustId$ | async; let trustId">
  <ng-container *appLoad="let trustSummary of trustSummary$; errorSizeClass: 'sm'; trackingName: 'trust-layout'">
    <spark-layout>

      <!-- slot / menu -->
      <layout-side-menu>

        <spark-shared-sidebar-sub-menu
          heading="Contacts"
          [backRoute]="['/Contacts']"
          [routePrefix]="routePrefix"
          [items]="items">
        </spark-shared-sidebar-sub-menu>

      </layout-side-menu>

      <!-- slot / content -->
      <layout-content>

        <div class="row">
          <div class="col trust">
            <div class="trust__header">
              <spark-contacts-trust-summary-panel 
                [trustSummary]="trustSummary">
              </spark-contacts-trust-summary-panel>
            </div>
            <div class="trust__content">
              <router-outlet></router-outlet>
            </div>
          </div>
        </div>

      </layout-content>

    </spark-layout>
  </ng-container>
</ng-container>
